export default __webpack_public_path__ + "static/media/stat-bg-icon.de7eef03.svg";